import React, { Component } from 'react';

import { connect } from 'react-redux';
import { StripeProvider, Elements } from 'react-stripe-elements';

import CheckoutForm from 'components/landlord_app/billing/CheckoutForm';
import { getBillingDetails, updateBillingDetails } from 'actions/companyDetailsActions';

import stripeConfig from 'config/services/stripe';

export default connect(
  store => ({
    userType: store.userTypes.loginAuth,
    billingDetails: store.companyDetails.billingDetails,
  }),
  dispatch => ({
    getBillingDetails: () => dispatch(getBillingDetails()),
    updateBillingDetails: data => dispatch(updateBillingDetails(data)),
  })
)(
  class CompanyProfile extends Component {
    UNSAFE_componentWillMount() {
      this.props.getBillingDetails();
    }

    render() {
      return (
        <StripeProvider apiKey={stripeConfig.api}>
          <div className="body" role="main">
            <div
              className="centers"
              style={{
                padding: '10px 0 0',
                margin: '10px auto',
                textAlign: 'center',
                marginBottom: '10px',
              }}
            >
              <span className="page-title">Billing Details</span>
              <Elements>
                <CheckoutForm
                  billingDetails={this.props.billingDetails}
                  updateBillingDetails={this.props.updateBillingDetails}
                  getBillingDetails={this.props.getBillingDetails}
                />
              </Elements>
            </div>
          </div>
        </StripeProvider>
      );
    }
  }
);
